import { useState, useContext, useEffect, useRef } from "react";

import blackDeleteIcon from "../../assets/black-delete-icon.svg";
import whiteRightIcon from "../../assets/white-right-icon.svg";
import uplaodIcon from "../../assets/upload-green-icon.svg";
import infoIcon from "../../assets/info-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import eyeIcon from "../../assets/eye-icon.svg";
import rejectIcon from "../../assets/cross-icon-red.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";
import { CaseServices } from "../../services/CaseServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import SuggestionBoxUtil from "../../utils/SuggestionBoxUtil";
import { toast } from "react-toastify";
import { AuthServices } from "../../services/AuthServices";

import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const InvestigationDocumentsForm = ({ data, caseStage }) => {
  const {
    caseDetails,
    setSelectedDocument,
    setSelectedImg,
    fetchLatestCaseStage,
    latestStageData,
  } = useContext(CaseStageContext);
  const [documentName, setDocumentName] = useState("");
  const [documentsData, setDocumentsData] = useState(
    latestStageData?.documents ?? null,
  );
  const [inputValue, setInputValue] = useState(null);
  const [suggestionResetKey, setSuggestionResetKey] = useState(0);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [percentage, setPercentage] = useState(0);
  const [documentDetails, setDocumentDetails] = useState(null);
  const [showDocReject, setShowDocReject] = useState(false);
  const [deniedReason, setDeniedReason] = useState("");
  const fileInputRef = useRef(null);
  // const documentsData = data || [];
  const suggestionStyles = {
    control: (base) => ({
      ...base,
      minHeight: "68px",
      height: "68px",
      borderRadius: "100px",
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "rgba(232, 232, 232, 0.6)",
      paddingLeft: "16px",
      paddingRight: "16px",
      boxShadow: "none",
      display: "flex",
      alignItems: "center",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),

    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: "8px",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#9CA3AF",
      fontFamily: "Lufga",
      fontSize: "14px",
    }),
  };

  async function renderPageToBlob(pdfDocument, pageNumber, scale = 1.5) {
    const canvas = document.createElement("canvas");
    const page = await pdfDocument.getPage(pageNumber);
    const viewport = page.getViewport({ scale });
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderContext = {
      canvasContext: canvas.getContext("2d"),
      viewport,
    };

    await page.render(renderContext).promise;

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error(`Failed to render page ${pageNumber} to blob`));
        }
      }, "image/jpeg");
    });
  }

  async function convertPdfToImageBlobs(pdfDocument, baseName) {
    const blobs = [];
    for (let i = 1; i <= pdfDocument.numPages; i++) {
      const blob = await renderPageToBlob(pdfDocument, i);
      blobs.push({
        blob,
        filename: `${baseName}_${i}.jpeg`,
      });
    }
    return blobs;
  }

  async function uploadBlobsToS3(blobs, setPercentage) {
    const formData = new FormData();
    for (const { blob, filename } of blobs) {
      formData.append("images", blob, filename);
    }

    const res = await AuthServices.uploadPdfToImage(formData, setPercentage);
    return res?.data?.urls || [];
  }
  async function saveUrlsToDb(
    urls,
    {
      documentDetails,
      sequencePrev,
      completeDocReupload,
      // refreshFunction,
      // handleClose,
    },
  ) {
    let sequence = sequencePrev ? sequencePrev : 0;
    const postData = urls.map((url) => {
      sequence++;
      return { documentUrl: url, sequence, urlId: "" };
    });

    await CaseServices.saveDocumentUrl(
      documentDetails.id,
      postData,
      completeDocReupload,
    );

    window.alert(`${documentDetails?.documentName} Uploaded Successfully`);
    // refreshFunction.getMappedDocuments();
    // handleClose();
    // await getLatestCaseStage();
    await fetchLatestCaseStage();
  }

  async function uploadDocument(event) {
    // setUploadStatus(true);
    // setIsSubmitting(true);

    try {
      const file = event.target.files[0];
      if (!file) return;

      const fileType = file.type.split("/")[0];
      // const baseName = documentDetails?.documentName || "document";
      const baseName = "document";

      let blobsToUpload = [];

      if (
        fileType === "application" &&
        file.name.toLowerCase().endsWith(".pdf")
      ) {
        // PDF path: load it, convert every page to a jpeg blob.
        const uri = URL.createObjectURL(file);
        const pdfDoc = await pdfjs.getDocument(uri).promise;
        blobsToUpload = await convertPdfToImageBlobs(pdfDoc, baseName);
      } else if (fileType === "image") {
        // Direct image path: just wrap it in the same { blob, filename } shape.
        blobsToUpload = [
          {
            blob: file,
            filename: `${baseName}.${file.type === "image/png" ? "png" : "jpeg"}`,
          },
        ];
      } else {
        window.alert("Unsupported file type. Please upload a PDF or image.");
        return;
      }

      // Upload everything to S3 in one go.
      const urls = await uploadBlobsToS3(blobsToUpload, setPercentage);

      if (urls.length > 0) {
        // Save resulting URLs straight to the DB — no selection step.
        await saveUrlsToDb(urls, {
          documentDetails,
          sequencePrev: 0,
          completeDocReupload: true,
          // refreshFunction,
          // handleClose,
        });
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      // setUploadStatus(false);
      // setIsSubmitting(false);
    }
  }
  const handleDocumentReApprove = async () => {
    try {
      console.log("re-approve");
      setShowDocReject(false);
      setDeniedReason("");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleDocumentReject = async () => {
    try {
      if (!deniedReason?.trim()) {
        alert("Please enter denial reason");
        return;
      }

      await CaseServices.updateDocumentStatus(documentDetails.id, {
        status: "REJECTED",
        completeDocRejected: true,
        rejectionReason: deniedReason,
        restrictCaseStageUpdate: true,
      });

      // await getLatestCaseStage();
      await fetchLatestCaseStage();

      toast.success("Document rejected successfully");
      setDeniedReason("");
      setShowDocReject(false);
    } catch (error) {
      console.log("Reject API Error", error);
    }
  };

  const handleAutoSuggestion = (selected, e) => {
    const docType = documentsData?.[0]?.documentType || "";

    setSelectedMapping({
      ...selected,
      documentType: docType,
    });
    console.log("selected value:", selected);
  };
  const handleMappedDocuments = async () => {
    const currentDocType = documentsData?.[0]?.documentType;
    const isEnhancementStage = documentsData?.[0]?.hsaStage
      ?.toLowerCase()
      ?.includes("enhancement");

    if (!selectedMapping && !inputValue) {
      toast.error("Please select at least one document");
      return;
    }

    const isAlreadyMapped = (docName) =>
      documentsData?.some((d) => d.documentName === docName);
    if (inputValue) {
      if (!isAlreadyMapped(inputValue)) {
        const documentDetails = {
          caseStatge: "",
          documentType: currentDocType,
          documentName: inputValue,
          required: true,
        };

        // setMappedDocuments((prev) => [...prev, documentDetails]);
        const payload = [
          {
            // caseId: caseDetails?.id,
            documentType: currentDocType,
            documentName: inputValue,
            ...(isEnhancementStage && {
              enhancementId: documentsData?.[0]?.enhancementId,
            }),
            // status: "PENDING",
            required: true,
          },
        ];
        try {
          const res = await CaseServices.updateMappedDocuments(
            payload,
            caseDetails?.id,
          );
          // await getLatestCaseStage();
          await fetchLatestCaseStage();
        } catch (error) {
          handleApiErrorResponses(error);
        }
        console.log("payload data:", payload);
      }

      setInputValue(null);
      setSelectedMapping(null);
      setSuggestionResetKey((prev) => prev + 1);
    }
    if (selectedMapping) {
      if (!isAlreadyMapped(selectedMapping.documentName)) {
        // setMappedDocuments((prev) => [...prev, selectedMapping]);
        const payload = [
          {
            // caseId: caseDetails?.id,
            documentType: currentDocType,
            documentName: selectedMapping.documentName,
            ...(isEnhancementStage && {
              enhancementId: documentsData?.[0]?.enhancementId,
            }),
            // status: "PENDING",
            required: true,
          },
        ];
        try {
          const res = await CaseServices.updateMappedDocuments(
            payload,
            caseDetails?.id,
          );
          // await getLatestCaseStage();
          await fetchLatestCaseStage();
        } catch (error) {
          handleApiErrorResponses(error);
        }
        console.log("payload data:", payload);
      }

      setSelectedMapping(null);
      setInputValue(null);
      setSuggestionResetKey((prev) => prev + 1);
    }
  };
  const getLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(caseDetails?.id);
      // console.log("latest stage documents res from investi: ", response.data);
      // if (response?.data?.currnetSubMasterStage[0]) {
      //   setDocumentsData(response?.data?.documents);
      // }
      setDocumentsData(response?.data?.documents);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    if (!latestStageData) return;
    // getLatestCaseStage();
    setDocumentsData(latestStageData?.documents);
  }, [latestStageData]);

  console.log("latest stage:", latestStageData);
  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      {/* Top Section */}
      <div className="flex items-center justify-between pt-[30px]">
        {/* Left Select */}
        {/* <div className="w-[280px] h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[14px] flex items-center">
          <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] whitespace-nowrap">
            {documentName || "Document Name"}
          </span>

          <div className="ml-auto flex items-center">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div> */}
        <div className="w-[24%]">
          <SuggestionBoxUtil
            api={CaseServices.defaultDocumentForSuggestionBox}
            handleChange={handleAutoSuggestion}
            name="documentName"
            setInputValue={setInputValue}
            resetKey={suggestionResetKey}
            styles={suggestionStyles}
            placeholder="Document Name"
            clearable={true}
          />
        </div>
        {/* Right Buttons */}
        <div className="flex items-center gap-[8px]">
          {/* Add Button */}
          <button
            className="w-[88px] h-[52px] 2xl:w-[88px] 2xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
            onClick={handleMappedDocuments}
          >
            ADD
          </button>

          {/* Add Other Documents */}
          <button className="w-[198px] h-[52px] rounded-[42px] border border-none bg-black flex items-center justify-center gap-[10px] uppercase font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] text-[#68FF9F]">
            ADD OTHER DOCUMENTS
            <span className="text-[30px] leading-none mb-[2px]">+</span>
          </button>
        </div>
      </div>
      {/* Table Section */}
      <div className="pt-[52px]">
        {/* Table Header */}
        <div className="grid xl:grid-cols-[1fr_24fr_8fr_1.5fr] xl:gap-x-[19px]  3xl:gap-x-[140px] items-start">
          {" "}
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Name
          </div>
          <div className="3xl:pl-11 font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Upload
          </div>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div>
        </div>

        {/* Table Body */}
        <div className="mt-[34px] flex flex-col gap-y-[34px]">
          {documentsData?.map((item, index) => (
            <div
              key={index}
              className="grid xl:grid-cols-[1fr_24fr_8fr_1.5fr] xl:gap-x-[19px]  3xl:gap-x-[140px] items-start"
            >
              {/* Number */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.{" "}
              </div>

              {/* Name */}
              <div className="truncate font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {`${item?.documentSubType ? item?.documentSubType + "-" : ""} ${item?.documentName || "--"}`}
              </div>

              {/* Upload */}
              <div className="flex items-center gap-[6px]">
                <img
                  src={uplaodIcon}
                  alt="upload"
                  onClick={() => {
                    setDocumentDetails(item);
                    fileInputRef.current.click();
                  }}
                />

                <a
                  href={item.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]"
                >
                  View Document
                </a>

                <img
                  src={eyeIcon}
                  alt="info"
                  onClick={() => {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                    setSelectedDocument(item);
                    if (item?.documenturlmasters?.length > 0) {
                      setSelectedImg({
                        idx: 0,
                        ...item.documenturlmasters[0],
                      });
                    }
                  }}
                />
              </div>

              {/* Delete */}
              <div className="flex gap-[16px] xl:gap-[14px]">
                {item?.status === "REJECTED" ? (
                  <button className="w-[55px] h-[28px] flex items-center justify-center rounded-[74.8px] border-[0.37px] border-solid bg-white border-[#FF4343] px-[8px] py-[6px]">
                    <span className="font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.05em] text-center align-middle text-[#FF4343]">
                      Denied
                    </span>
                  </button>
                ) : (
                  <button
                    className="flex items-center justify-self-end bg-transparent border-none"
                    onClick={() => {
                      setDocumentDetails(item);
                      setShowDocReject(true);
                    }}
                  >
                    <img src={rejectIcon} alt="reject-icon" />
                  </button>
                )}
                {/* <button className="flex items-center justify-self-end bg-transparent border-none">
                  <img src={blackDeleteIcon} alt="delete icon" />
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Save Section */}
      {/* <div className="flex justify-end items-center gap-[10px] mt-[40px]">
        <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
          SAVED
          <img src={whiteRightIcon} alt="white icon" />
        </button>

        <button className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent">
          <img src={editIcon} alt="edit icon" />
        </button>
      </div> */}
      <input
        type="file"
        onChange={uploadDocument}
        style={{ display: "none" }}
        ref={fileInputRef}
        accept=".pdf,.png,.jpg,.jpeg"
      />
      {showDocReject && (
        <div>
          <div className="fixed inset-0 z-30 flex justify-center items-center">
            <div className="w-[442px] h-[330px] rounded-[24px]  border-solid  border-[#FF0000] border-[1px] bg-[#E8B4B4F2] px-[2px] py-[50px] flex flex-col items-center">
              {/* Title */}
              <h2 className="font-lufga font-normal text-[32px] leading-[100%] tracking-[-0.39px] text-center text-white capitalize">
                Document Denied!
              </h2>

              {/* Subtitle */}
              <p className="mt-[1px] font-lufga font-light text-[12px] leading-[100%] tracking-[-0.39px] text-center text-white">
                Enter a reason why are you Denying the Document ?
              </p>

              {/* Reason Field */}
              <input
                type="text"
                value={deniedReason}
                onChange={(e) => setDeniedReason(e.target.value)}
                placeholder="Type Document denied reason"
                className="w-[332px] h-[84px] mt-[16px] rounded-[24px] border-solid border-[#FFFFFF] bg-[#FFFFFF33] px-[18px] outline-none font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-black placeholder:text-white"
              />

              {/* Buttons */}
              <div className="flex items-center gap-[24px] mt-[16px]">
                <button
                  onClick={handleDocumentReApprove}
                  className="w-[100px] h-[40px] rounded-[24px] bg-white border border-none flex items-center justify-center font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.39px] text-black capitalize"
                >
                  Re-Approve
                </button>

                <button
                  onClick={handleDocumentReject}
                  className="w-[97px] h-[40px] rounded-[24px] bg-[#FF4343] border border-none flex items-center justify-center font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.39px] text-white capitalize"
                >
                  Doc Denied
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvestigationDocumentsForm;
